import { createStore, applyMiddleware } from "redux"
import rootReducers from "./reducers/rootReducers"
import {composeWithDevTools} from "redux-devtools-extension";
import trunk from "redux-thunk";
import { persistStore, persistReducer } from 'redux-persist'
import storage from 'redux-persist/lib/storage' // defaults to localStorage for web

const persistConfig = {
    key: 'root',
    version: 1,
    storage,
 };
const presistedReducer = persistReducer(persistConfig, rootReducers );
const store =  createStore(presistedReducer, composeWithDevTools(applyMiddleware(trunk)));

export default store;
